const DB_NAME = "aegis-offline";
const STORE = "queue";

function openDb() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB_NAME, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: "client_event_id" });
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

export async function queueEvent(ev) {
  const d = await openDb();
  return new Promise((res, rej) => {
    const tx = d.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(ev);
    tx.oncomplete = () => res();
    tx.onerror = () => rej(tx.error);
  });
}

export async function pendingEvents() {
  try {
    const d = await openDb();
    return await new Promise((res, rej) => {
      const tx = d.transaction(STORE, "readonly");
      const req = tx.objectStore(STORE).getAll();
      req.onsuccess = () => res(req.result || []);
      req.onerror = () => rej(req.error);
    });
  } catch (e) {
    return [];
  }
}

export async function removeEvent(id) {
  const d = await openDb();
  return new Promise((res, rej) => {
    const tx = d.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => res();
    tx.onerror = () => rej(tx.error);
  });
}

export async function syncQueue(api) {
  const pending = await pendingEvents();
  if (!pending.length) return { synced: 0, duplicates: 0 };
  const { data } = await api.post("/attendance/sync", { events: pending });
  let synced = 0, duplicates = 0;
  for (const r of data.results || []) {
    if (r.status === "recorded") synced += 1;
    if (r.status === "duplicate") duplicates += 1;
    if (r.status !== "error") await removeEvent(r.client_event_id);
  }
  return { synced, duplicates };
}
